import React, { useState, useEffect } from "react";
import SafetyApp from "../../../../assets/images/wifi-squeeze/SafetyApp.png";
import logo from "../../../../assets/images/wifi-squeeze/logo.png";
import toy2 from "../../../../assets/images/wifi-squeeze/toy2.png";
import toy from "../../../../assets/images/wifi-squeeze/toy.png";
import logo2 from "../../../../assets/images/wifi-squeeze/logo2.png";
import talk from "../../../../assets/images/wifi-squeeze/talk.png";
import { fetchData } from "../../../../services";
import { useParams } from "react-router-dom";
import PageLoader from "../../../util/PageLoader";

function WifiSqueezeLanding() {
  const { id } = useParams();
  const [items, setItems] = useState({});
  const [loading, setLoading] = useState(true);

  const getItemsDetails = async () => {
    setLoading(true);
    const resp = await fetchData(`getHotelWifiSqueeze/${id}`);
    if (resp?.type === "success") {
      setItems(resp?.payload);
      setLoading(false);
    }
  };

  useEffect(() => {
    getItemsDetails();
  }, []);

  if (loading) {
    return <PageLoader />;
  }

  return (
    <>
      <div
        className="outerWrapper_wifi"
        style={{
          background: `url(${items?.background_image}) no-repeat center center / cover`,
        }}
      >
        <header style={{ backgroundColor: items?.header_color }}>
            <img className="logo1" src={items.logo} alt="Logo" />
             <img className="logo2" src={SafetyApp} alt="SafetyApp" />
        </header>

        <div className="wifi-box">
          <div className="mobile-img toy-mbl">
            <img src={toy2} alt="" />
          </div>

          <div className="form-section">
            <h2>Connect to free Wi-Fi</h2>

            {items?.fields_name?.Name === true && (
              <div className="form-group">
                <label htmlFor="name">Name:</label>
                <input type="text" id="name" placeholder="John Cena" />
              </div>
            )}

            {items?.fields_name?.Phone === true && (
              <div className="form-group">
                <label htmlFor="phone">Phone:</label>
                <input type="text" id="phone" placeholder="+1 555 - 0201" />
              </div>
            )}

            {items?.fields_name?.Email === true && (
              <div className="form-group">
                <label htmlFor="email">Email:</label>
                <input type="text" id="email" placeholder="email" />
              </div>
            )}

            {items?.fields_name?.["Room Key"] === true && (
              <div className="form-group">
                <label htmlFor="room">Room Number:</label>
                <input type="text" id="room" placeholder="9170" />
              </div>
            )}

            <div className="terms">
              <label className="custom-checkbox">
                <input type="checkbox" id="agree" />
                <span className="checkmark"></span>I agree to the terms and
                conditions
              </label>
            </div>

            <div className="privacy-text">
              We respect your privacy. Your details won’t be shared. No spam –
              ever.
            </div>

            <div className="form-group text-center">
              <button className="submit-btn-wifi">Connect &amp; Play</button>
            </div>
          </div>

          <div className="mascot">
            <img className="desktop-img toy" src={toy} alt="Mascot" />
            <img className="logo2" src={logo2} alt="" />
            <div className="talkwrapper">
              <img className="desktop-img talk" src={talk} alt="Talk bubble" />
              <p>PSST... DOWNLOAD THE APP NEXT TO WIN DAILY!</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default WifiSqueezeLanding;
